import { useLiveViewContext } from "./LiveViewContext";
import { LiveDot } from "./LiveDot";

/**
 * A green dot next to an applicant who is in the applicant app right now,
 * e.g. in the application header's applicant tabs. Renders nothing otherwise.
 */
export const ApplicantPresenceDot = ({
  applicantId
}: {
  applicantId: number;
}) => {
  const entry = useLiveViewContext()?.presence.get(applicantId);
  if (!entry) return null;
  const label = `In application now · ${entry.step}`;

  return (
    <span title={label} className="mr-1.5 inline-flex align-middle">
      <LiveDot />
      <span className="sr-only">{label}</span>
    </span>
  );
};
